import React from "react";
import CarMasterData from "./carMasterData";

const TypesList = () => {
  const tabeName = "carCategory";

  return (
    <>
      <CarMasterData tabeName={tabeName} />
    </>
  );
};

export default TypesList;
